/**
 * @description Base controller for two separate portal controllers
 * @example
 * // Inside child controller
 * var baseCtrl = $controller('BaseVulnEventsCtrl', {$scope: $scope});
 */
;(function () {
  'use strict'

  angular
    .module('contrast.vulnerabilities')
    .controller('BaseVulnEventsCtrl', BaseVulnEventsCtrl)

  function BaseVulnEventsCtrl($scope, $rootScope, $routeParams, $location) {
    'ngInject'

    this.$onInit = function () {
      angular.extend($scope, {
        eventsOpen: 0,
        // TODO:FakeNews CONTRAST-14644 remove when real data mapping is in place
        mockGraphData: {
          nodes: [
            {
              data: {
                id: 'n0',
                name: 'Input A',
                subtitle: 'Subtitle',
                type: 'input'
              }
            },
            {
              data: {
                id: 'n1',
                name: 'Input A Received',
                type: 'receipt',
                percentage: 88
              }
            },
            { data: { id: 'n2', name: 'Process', subtitle: 'Subtitle' } },
            {
              data: {
                id: 'n3',
                name: 'Complete',
                subtitle: 'Subtitle',
                type: 'final'
              }
            },
            {
              data: {
                id: 'n4',
                name: 'Input B',
                subtitle: 'Subtitle',
                type: 'input'
              }
            },
            {
              data: {
                id: 'n5',
                name: 'Input B Received',
                type: 'receipt',
                percentage: 25
              }
            }
          ],
          edges: [
            { data: { source: 'n0', target: 'n1' } },
            { data: { source: 'n1', target: 'n2' } },
            { data: { source: 'n2', target: 'n3' } },
            { data: { source: 'n4', target: 'n5' } },
            { data: { source: 'n5', target: 'n2' } }
          ]
        }
      })

      angular.extend($scope, {
        getTraceUuid: getTraceUuid,
        getTraceLanguage: getTraceLanguage,
        afterGetEvents: afterGetEvents,
        getTempOptions: getTempOptions
      })

      init()
    }
    var _uuid

    function init() {
      _uuid = $routeParams.uuid
      _determineFakeNewsTempOptions()
    }

    function _determineFakeNewsTempOptions() {
      var s = $location.search()
      $scope.model.tempOptions = {
        legacy: s.legacy ? true : false
      }
    }

    // TODO:FakeNews remove before final merge or when data is available
    function getTempOptions() {
      return $scope.$parent.$parent.model.tempOptions
    }

    function getTraceUuid() {
      return _uuid
    }

    function getTraceLanguage() {
      return $scope.language
    }

    function _initDefaultValues() {
      _initLanguage()
    }

    function _initLanguage() {
      if ($scope.$parent.model.trace) {
        $scope.language = $scope.$parent.model.trace.application.language
      }
    }

    function _broadCastHideDetailsTabEvent() {
      $rootScope.$broadcast('hide.details.tab', true)
    }

    function afterGetEvents(data) {
      $scope.model = data
      if (!data.showEvents) {
        _broadCastHideDetailsTabEvent()
      }
      _initDefaultValues()
    }
  }
})()
